'use client';

import { CustomError, isEnumValue } from '@core/utils';
import { useSearchParams } from 'next/navigation';

import { COMMENT_SORT_TYPE } from '@/api';
import { SEARCH_PARAMS } from '@/constants';

// 댓글 정렬 상태는 다른 화면 공유와 새로고침 복원을 위해 URL에 남긴다.
const replaceSortTypeInUrl = (sortType: COMMENT_SORT_TYPE) => {
  const url = new URL(window.location.href);
  url.searchParams.set(SEARCH_PARAMS.SORT_TYPE, sortType);
  window.history.replaceState(
    null,
    '',
    `${url.pathname}${url.search}${url.hash}`,
  );
};

// CommentThread가 정렬 상태를 읽고 쓰는 최소 인터페이스만 노출한다.
export const useCommentThreadNavigation = () => {
  const searchParams = useSearchParams();

  // 정렬 상태는 아직 공유 URL 요구가 있어 query string과 동기화한다.
  const rawSortType =
    searchParams?.get(SEARCH_PARAMS.SORT_TYPE) ?? COMMENT_SORT_TYPE.LATEST;
  if (!isEnumValue(COMMENT_SORT_TYPE, rawSortType)) {
    throw new CustomError({
      return_message: '잘못된 sortType입니다.',
    });
  }

  const sortType = rawSortType;

  const handleChangeSortType = (nextSortType: COMMENT_SORT_TYPE) => {
    replaceSortTypeInUrl(nextSortType);
  };

  const resetSortType = () => {
    if (sortType === COMMENT_SORT_TYPE.LATEST) return;

    replaceSortTypeInUrl(COMMENT_SORT_TYPE.LATEST);
  };

  return {
    sortType,
    handleChangeSortType,
    resetSortType,
  };
};
